import React, { useState } from 'react'
import styles from "./FeedbackAndSuggestions.module.scss"
import DynamicDatatable from '../../../../components/common/AdminCommonComponents/DynamicDatatable/DynamicDatatable'
import { Col, Container, Row } from 'reactstrap'
import MessagesComp from '../../../../components/AdminPortalComponents/Support&Communication/Messages/Messages.comp'
import SupportTicketsComp from '../../../../components/AdminPortalComponents/Support&Communication/SupportTickets/SupportTickets.comp'
import SearchBar from '../../../../components/common/AdminCommonComponents/SearchBar/SearchBar'
import FeedbackAndSuggestionsComp from '../../../../components/AdminPortalComponents/Support&Communication/Feedback&Suggestions/FeedbackAndSuggestions.comp'
import ComponentBackButton from '../../../../components/common/AdminCommonComponents/Buttons/ComponentBackButton/ComponentBackButton'
import DetailsCard from '../../../../components/common/AdminCommonComponents/DetailsCard/DetailsCard'
import DynamicButton from '../../../../components/common/AdminCommonComponents/Buttons/DynamicButton/DynamicButton'

function FeedbackAndSuggestions() {
    const [messageDetails, setMessageDetails] = useState(false)
    const tableData = [
        { type: "Suggestions", count: 5, percentage: 10 },
        { type: "Feature Requests", count: 5, percentage: 10 },
        { type: "Issues/Problems", count: 5, percentage: 10 },
        { type: "Total", count: 5, percentage: 10 },
    ]
    const tableCols = [
        {
            name: "Feedback Type",
            selector: (row) => row.type,
        },
        {
            name: "Count",
            selector: (row) => row.count,
        },
        {
            name: "Percentage",
            selector: (row) => row.percentage,
        },
    ]
    return (
        <div className={styles.mainContainer}>
            <Container className={styles.filterTableWrapper}>
                <DynamicDatatable data={tableData} columns={tableCols} type={"yellow"} />
            </Container>
            {!messageDetails &&
                <>
                    <Container className={styles.filterTableWrapper}>
                        <div className="p-3 d-flex align-items-center justify-content-between">
                            <div className={`fw-semibold fs-4 ${styles.text} `}>Feedback Management </div>
                            <SearchBar placeholder={"Keyword, user name,. or feedback ID"} />
                        </div>
                        <FeedbackAndSuggestionsComp setActive={() => setMessageDetails(true)} onClick={() => setMessageDetails(true)} />
                    </Container>
                </>
            }
            {
                messageDetails &&
                <Container fluid className={styles.orderWrapper}>
                    <ComponentBackButton onClick={() => setMessageDetails(false)} />
                    <div className={`${styles.detailsContainer} container`}>
                        <Row className="row-cols-1 row-cols-md-2 row-cols-lg-3">

                            <Col className=" d-grid">
                                <DetailsCard titleColor title={"Feedback Information"}>
                                    <div className={styles.cont}>
                                        <div className={styles.text1}>ID:</div>
                                        <div>001</div>
                                    </div>
                                    <div className={`${styles.cont} ${styles.border}`}>
                                        <div className={styles.text1}>User Name:</div>
                                        <div>John doe</div>
                                    </div>
                                    <div className={styles.cont}>
                                        <div className={styles.text1}>Rating:</div>
                                        <div>4</div>
                                    </div>
                                    <div className={`${styles.cont} ${styles.border}`}>
                                        <div className={styles.text1}>Type:</div>
                                        <div>Suggestion</div>
                                    </div>
                                    <div className={styles.cont2}>
                                        <div className={styles.blueText}>Date Submitted:</div>
                                        <div>12-11-2090</div>
                                    </div>
                                    <div className={styles.cont2}>
                                        <div className={styles.text1}>Status:</div>
                                        <div className={styles.yellowText}>Pending</div>
                                    </div>
                                </DetailsCard>
                            </Col>

                            <Col className=" d-grid">
                                <DetailsCard titleColor title={"Feedback Content"}>
                                </DetailsCard>
                            </Col>

                            <Col className=" d-grid">
                                <DetailsCard title={"Refund Reason"}>

                                    <div className={styles.cont}>
                                        <div >Reply:</div>
                                        <div className={styles.redText}></div>
                                    </div>

                                    <div className={styles.cont}>
                                        <div >Assign:</div>
                                        <div></div>
                                    </div>
                                    <div className={styles.cont}>
                                        <div >Change Status:</div>
                                        <div></div>
                                    </div>
                                    <div className={styles.cont}>
                                        <div >Add Internal Note:</div>
                                        <div></div>
                                    </div>


                                </DetailsCard>
                            </Col>

                        </Row>
                    </div>


                </Container>

            }

        </div>
    )
}

export default FeedbackAndSuggestions
